import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

const TypeSelect = ({ value, onChange }) => {
  return (
    <Form.Group controlId="typeSelect" className="d-flex align-items-center">
      <Form.Label style={{ width: '100px' }}>Type:</Form.Label>
      <Form.Control
        as="select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="AQUATIC_ANIMAL">Animal aquatique</option>
        <option value="DOMESTIC_ANIMAL">Animal domestique</option>
        <option value="WILD_ANIMAL">Animal sauvage</option>
        <option value="INSECT">Insecte</option>
        <option value="BIRD">Oiseau</option>
        <option value="BUTTERFLY">Papillon</option>
        <option value="BIRD_OF_PREY">Rapace</option>
      </Form.Control>
    </Form.Group>
  )
}

TypeSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default TypeSelect
